import { FrmEventBus } from '../eventbus/frm-evenbus';
import { IframeLink } from '../models/iframe.model';
import { Subscription, Subject } from 'rxjs';
import { EventBusPipe } from '../eventbus/frm-eventpipe';
import { FrameworkVariableService } from '../services/frmVariableService/framework-variable.service';

export class FrmUtil {

    public static setHeader(bizContextId: string, options: any) {
        options.headers = {
            'Content-Type': 'application/json',
        };
        if (bizContextId) {
            const contextKey = 'X-CAF-Runtime-Context';
            options.headers[contextKey] = bizContextId;
        }
        return options;
    }

    public static getTabArray(): IframeLink[] {
        const iframeTabArr = 'iframeTabarray';
        const topWin = this.getTopWindow();
        let frmWin: Window = window;
        while ((!frmWin[iframeTabArr] || frmWin[iframeTabArr].length === 0) && frmWin !== topWin) {
            frmWin = frmWin.parent;
        }
        return frmWin[iframeTabArr] as IframeLink[] || [];
    }

    public static getTopWindow(): Window {
        let curWin: Window = window.self;
        try {
            while (curWin.location.origin === curWin.parent.location.origin) {
                if (curWin !== curWin.parent && !(curWin as any).isRTFTopWin) {
                    curWin = curWin.parent;
                } else {
                    break;
                }
            }
        } catch (e) { }
        return curWin;
    }

    public static removeTab(index: number) {
        const iframeArr = this.getTabArray();
        iframeArr.splice(index, 1);
    }
}

export class EventUtil {

    /** eventToken str */
    public static FARRIS_APPS = 'all-gsp-farrisapps';
    public static FARRIS_APP_CLICK = 'farrisapp-click';
    public static ALL_GSP_FUNCS = 'all-gsp-functions';
    public static BEFORE_FUNC_CLOSE = 'beforeFuncCloseEvent';
    public static FUNC_CLOSED = 'FuncClosed';
    public static FUNC_SWITCH = 'funcSwitchEvent';
    public static AFTER_FRAME_LOAD = "after-iframe-load-event";
    private static eventBusKey = 'frmEventBus';

    private static frmVariable = new FrameworkVariableService();

    /** 获取框架event */
    public static getFrmEvent(): FrmEventBus {
        const eventBus = this.frmVariable.getFrmVariableByKey(this.eventBusKey);
        return eventBus as FrmEventBus;
    }

    public static setFrmEvent(feb: FrmEventBus) {
        this.frmVariable.frameworkVariableReg(this.eventBusKey, feb);
    }

    /**
     * 获取app唯一的观察者标识
     */
    public static appObsToken(appId: string, appEntrance: string, tabId?: string): string {
        return tabId || `${appId}#${appEntrance}`;
    }

    /**
     * 获取func唯一的观察者标识
     */
    public static funcObsToken(funcId: string, tabId?: string): string {
        return tabId || funcId;
    }

    /**
     * 获取某事件的监听者
     */
    public static getObserver(eventToken: string): Map<string, Subscription> {
        const feb = this.getFrmEvent();
        const eventMap = feb.eventMap.get(eventToken);
        if (!eventMap) {
            return null;
        }

        let eventPipe: EventBusPipe;
        for (const eventPipeDetail of eventMap) {
            if (eventPipeDetail.matchEmitterToken(eventToken)) {
                eventPipe = eventPipeDetail;
                break;
            }
        }
        if (!eventPipe) {
            return null;
        }
        const obs = eventPipe.observers;
        return obs;
    }

    /**
     * 获取某事件的销毁事件
     */
    public static getObserverDestroySub(eventToken: string): Map<string, any> {
        const feb = this.getFrmEvent();
        const eventMap = feb.eventMap.get(eventToken);
        if (!eventMap) {
            return null;
        }

        let eventPipe: EventBusPipe;
        for (const eventPipeDetail of eventMap) {
            if (eventPipeDetail.matchEmitterToken(eventToken)) {
                eventPipe = eventPipeDetail;
                break;
            }
        }
        if (!eventPipe) {
            return null;
        }
        const obsDestroySub = eventPipe.observersDestroy$;
        return obsDestroySub;
    }

    /**
     * 清空监听者
     */
    public static clearObserver(obKey: string) {
        const feb = this.getFrmEvent();
        feb.unSubscribeWithObKey(this.FUNC_SWITCH, obKey);
        feb.unSubscribeWithObKey(this.FUNC_CLOSED, obKey);
        feb.unSubscribeWithObKey(this.BEFORE_FUNC_CLOSE, obKey);
        // const switchObsDestorySubMap = this.getObserverDestroySub(this.FUNC_SWITCH);
        // const $switchObs = switchObsDestorySubMap.get(obKey);
        // if ($switchObs) {
        //     $switchObs.next();
        //     $switchObs.complete();
        //     switchObsDestorySubMap.set(obKey, null);
        //     switchObsDestorySubMap.delete(obKey);
        // }
        // const closeObsDestroySubMap = this.getObserverDestroySub(this.FUNC_CLOSED);
        // const $closeObs = closeObsDestroySubMap.get(obKey);
        // if ($closeObs) {
        //     $closeObs.next();
        //     $closeObs.complete();
        //     closeObsDestroySubMap.set(obKey, null);
        //     closeObsDestroySubMap.delete(obKey);
        // }
        // const beforeCloseDestroySubMap = this.getObserverDestroySub(this.BEFORE_FUNC_CLOSE);
        // const $beforeClose = beforeCloseDestroySubMap.get(obKey);
        // if ($beforeClose) {
        //     $beforeClose.next();
        //     $beforeClose.complete();
        //     beforeCloseDestroySubMap.delete(obKey);
        // }

        // const switchObsMap = this.getObserver(this.FUNC_SWITCH);
        // const switchObs = switchObsMap.get(obKey);
        // if (switchObs) {
        //     switchObs.unsubscribe();
        //     switchObsMap.delete(obKey);
        // }
        // const closeObsMap = this.getObserver(this.FUNC_CLOSED);
        // const closeObs = closeObsMap.get(obKey);
        // if (closeObs) {
        //     closeObs.unsubscribe();
        //     closeObsMap.delete(obKey);
        // }
        // const beforeCloseMap = this.getObserver(this.BEFORE_FUNC_CLOSE);
        // const beforeClose = beforeCloseMap.get(obKey);
        // if (beforeClose) {
        //     beforeClose.unsubscribe();
        //     beforeCloseMap.delete(obKey);
        // }

    }

     /**
     * 清空某个管道
     */
    public static clearEventPipeWithObkey(pipeToken: string, obsKey: string) {
        const feb = this.getFrmEvent();
        feb.unSubscribeWithObKey(pipeToken, obsKey);
    }

    /**
     * 清空某个管道
     */
    public static clearEventPipe(pipeToken: string) {
        const feb = this.getFrmEvent();
        feb.unSubscribe(pipeToken);
        feb.clearSubject(pipeToken);
        // const eventPipes = feb.eventMap.get(pipeToken);
        // if (!eventPipes) {
        //     return;
        // }
        // const eventPipe = eventPipes.find(item => item.examByTargetToken(pipeToken));
        // if (eventPipe) {
        //     eventPipe.unSubscribe();
        //     feb.eventMap.delete(pipeToken);
        // }
    }
}

export const AppType = {
    App: 'app',
    Menu: 'menu',
    Other: 'other'
};

export interface FuncEventArgs {
    /** 当前tab页的唯一标识 */
    tabId: string;
    /** 当前tab打开的功能类型 app or menu */
    appType: string;
    funcId?: string;
    appId?: string;
    appEntrance?: string;
    tabName?: string;
    beforeCloseHandle?: (arg: any) => void;
}

export interface FuncStateParam {
    /**
     * formToken (简称 cvft)
     */
    token?: string;
    /** 当前tab页的唯一标识 */
    tabId: string;
    funcId?: string;
    appId?: string;
    appEntrance?: string;
    /**
     * 当页面name自定义时为自定义
     * 否则：func为funcName，app为entryName
     */
    menuName: string;
    /**
     * 动作
     */
    action: string;

    /**
     * 租户路由维度信息
     * 可选参数，中交多租户场景使用
     */
    tRouteDim?: string;

    preState?: string;
}

export interface AppOptions {
    /**
     * 指定当前打开的是菜单（menu）还是应用（app）
     * 可选参数，缺省为菜单（menu）
     */
    appType?: string;

    /*** 如果打开菜单，funcId需要指定，appId、appEntrance可以为空 */
    funcId: string;

    /*** 如果打开应用，appId及appEntrance需要指定，funcId可以为空 */
    appId?: string;
    appEntrance?: string;

    /** 如果需要重复打开功能，则自行指定唯一tabId */
    tabId?: string;
    tabName?: string;

    /**
     * 表单公共变量token/formToken
     */
    token?: string;
    /**
     * 表单所属SU
     */
    su?: string;
    routeUrl?: string;
    entityParams?: any;
    queryStringParams?: Map<string, string>;
    isReload?: boolean;
    isJquery?: boolean;
    /**
     * spa模式下重复打开功能
     * true：构造新的页面实例
     * false || null || undefined：复用已打开的页面实例
     * 目前新的tabId就是新的页面实例
     */
    isNewTab?: boolean;

    /**
     * 只获取被打开表单的link实体，
     * 不触发框架加载表单实践
     */
    onlyGetIframeLink?: boolean;

    isChangeTenant?: boolean;
    /**
     * 租户路由维度信息 {key: value, key2: value2}
     */
    tenantRouteDim?: any;
    tenantId?: number;
    preState?: AppOptions;

    opCustomParam?: string;

    /**
     * 关闭前回调处理
     */
    beforeCloseHandle?: (arg: any) => void;
}

export interface FrmSubjectOptions {
    customToken?: string;
    funcId?: string;
    appId?: string;
    appEntrance?: string;
}

